import request from "@/utils/request"

export function getTermList(data) {
  return request({
    url: "/server/manage/list",
    method: "get",
    params: data,
  })
}

export function addTerm(data) {
  return request({
    url: "/server/manage/add",
    method: "POST",
    data: data,
  })
}

export function editTerm(data) {
  return request({
    url: "/server/manage/edit",
    method: "POST",
    data: data,
  })
}
export function removeTerm(data) {
  return request({
    url: "/server/manage/remove",
    method: "POST",
    data: data,
  })
}
export function addType(data) {
  return request({
    url: "/server/type/add",
    method: "POST",
    data: data,
  })
}
export function editType(data) {
  return request({
    url: "/server/type/edit",
    method: "POST",
    data: data,
  })
}

export function deleteType(data) {
  return request({
    url: "/server/type/remove",
    method: "POST",
    data: data,
  })
}

export function getTypeLlist(data) {
  return request({
    url: "/server/type/select",
    method: "GET",
    params: data,
  })
}

export function getTemplateList(data) {
  return request({
    url: "/server/templateTitle/list",
    method: "GET",
    params: data,
  })
}
export function editTemplate(data) {
  return request({
    url: "/server/templateTitle/edit",
    method: "POST",
    data: data,
  })
}

export function addTemplate(data) {
  return request({
    url: "/server/templateTitle/add",
    method: "POST",
    data: data,
  })
}

export function removeTemplate(data) {
  return request({
    url: "/server/templateTitle/remove",
    method: "POST",
    data: data,
    params: data,
  })
}
export function getTemplate(data) {
  return request({
    url: "/server/templateTitle/getInfo/" + data,
    method: "GET",
  })
}
export function previewTerms(data) {
  return request({
    url: `/server/templateTitle/scan`,
    method: "POST",
    data: data,
  })
}
export function addBatch(data) {
  return request({
    url: `/server/manage/addBatch`,
    method: "POST",
    data: data,
  })
}
